export const NAV = {
  fr: {
    groups: [
      {
        key: "cabinet",
        label: "Le Cabinet",
        items: [
          { to: "/a-propos", label: "À propos" },
          { to: "/equipe", label: "Équipe" },
          { to: "/culture", label: "Culture" },
          { to: "/valeurs", label: "Valeurs" },
          { to: "/carrieres", label: "Carrières" },
        ],
      },
      {
        key: "expertises",
        label: "Expertises",
        items: [
          { to: "/expertises", label: "Vue d'ensemble" },
          { to: "/expertises/conseil-capital-prive", label: "Conseil en capital privé" },
          { to: "/expertises/origination-execution", label: "Origination & exécution" },
          { to: "/expertises/operations-structuration", label: "Opérations & structuration" },
          { to: "/expertises/reglementaire-conformite", label: "Réglementaire & conformité" },
          { to: "/expertises/communication-investisseurs", label: "Communication investisseurs" },
          { to: "/expertises/intelligence-marche", label: "Intelligence de marché" },
          { to: "/expertises/conseil-strategique", label: "Conseil stratégique" },
        ],
      },
      {
        key: "clients",
        label: "Clients",
        items: [
          { to: "/clients/investisseurs-prives", label: "Investisseurs privés" },
          { to: "/clients/entreprises", label: "Entreprises" },
          { to: "/clients/societes-cotees", label: "Sociétés cotées" },
          { to: "/clients/fonds-institutions", label: "Fonds & institutions" },
          { to: "/clients/gestion-fortune", label: "Gestion de fortune" },
        ],
      },
      {
        key: "standards",
        label: "Standards",
        items: [
          { to: "/standards/assurance-client", label: "Assurance client" },
          { to: "/standards/modele-operationnel", label: "Modèle opérationnel" },
          { to: "/standards/gouvernance", label: "Gouvernance" },
          { to: "/standards/approche-reglementaire", label: "Approche réglementaire" },
          { to: "/standards/securite", label: "Sécurité" },
          { to: "/standards/durabilite", label: "Durabilité" },
          { to: "/standards/programme-partenaires", label: "Programme partenaires" },
        ],
      },
      {
        key: "investissements",
        label: "Investissements",
        items: [
          { to: "/investissements", label: "Notre approche" },
          { to: "/portfolio", label: "Portfolio" },
          { to: "/secteurs", label: "Secteurs" },
        ],
      },
    ],
    links: [
      { to: "/insights", label: "Insights" },
      { to: "/faq", label: "FAQ" },
    ],
    cta: "Consultation privée",
    breadcrumbHome: "Accueil",
    readMore: "Lire l'article",
    ctaBand: {
      title: "Prêt à structurer votre prochaine décision ?",
      text: "Confidentiel et sans engagement. Un conseiller senior vous répond sous 24 h ouvrées.",
      button: "Demander un rendez-vous",
    },
  },
  en: {
    groups: [
      {
        key: "cabinet",
        label: "The Firm",
        items: [
          { to: "/a-propos", label: "About" },
          { to: "/equipe", label: "Team" },
          { to: "/culture", label: "Culture" },
          { to: "/valeurs", label: "Core values" },
          { to: "/carrieres", label: "Careers" },
        ],
      },
      {
        key: "expertises",
        label: "Expertise",
        items: [
          { to: "/expertises", label: "Overview" },
          { to: "/expertises/conseil-capital-prive", label: "Private capital advisory" },
          { to: "/expertises/origination-execution", label: "Deal origination & execution" },
          { to: "/expertises/operations-structuration", label: "Operations & structuring" },
          { to: "/expertises/reglementaire-conformite", label: "Regulatory & compliance" },
          { to: "/expertises/communication-investisseurs", label: "Investor communications" },
          { to: "/expertises/intelligence-marche", label: "Market intelligence" },
          { to: "/expertises/conseil-strategique", label: "Strategic consulting" },
        ],
      },
      {
        key: "clients",
        label: "Who we serve",
        items: [
          { to: "/clients/investisseurs-prives", label: "Private investors" },
          { to: "/clients/entreprises", label: "Corporations" },
          { to: "/clients/societes-cotees", label: "Public companies" },
          { to: "/clients/fonds-institutions", label: "Funds & institutions" },
          { to: "/clients/gestion-fortune", label: "Wealth management" },
        ],
      },
      {
        key: "standards",
        label: "Standards",
        items: [
          { to: "/standards/assurance-client", label: "Client assurance" },
          { to: "/standards/modele-operationnel", label: "Operating model" },
          { to: "/standards/gouvernance", label: "Governance" },
          { to: "/standards/approche-reglementaire", label: "Regulatory approach" },
          { to: "/standards/securite", label: "Security" },
          { to: "/standards/durabilite", label: "Sustainability" },
          { to: "/standards/programme-partenaires", label: "Partner program" },
        ],
      },
      {
        key: "investissements",
        label: "Investments",
        items: [
          { to: "/investissements", label: "Our approach" },
          { to: "/portfolio", label: "Portfolio" },
          { to: "/secteurs", label: "Sectors" },
        ],
      },
    ],
    links: [
      { to: "/insights", label: "Insights" },
      { to: "/faq", label: "FAQ" },
    ],
    cta: "Private consultation",
    breadcrumbHome: "Home",
    readMore: "Read article",
    ctaBand: {
      title: "Ready to structure your next decision?",
      text: "Confidential and without obligation. A senior advisor replies within one business day.",
      button: "Request a meeting",
    },
  },
  de: {
    groups: [
      {
        key: "cabinet",
        label: "Das Unternehmen",
        items: [
          { to: "/a-propos", label: "Über uns" },
          { to: "/equipe", label: "Team" },
          { to: "/culture", label: "Kultur" },
          { to: "/valeurs", label: "Werte" },
          { to: "/carrieres", label: "Karriere" },
        ],
      },
      {
        key: "expertises",
        label: "Expertisen",
        items: [
          { to: "/expertises", label: "Übersicht" },
          { to: "/expertises/conseil-capital-prive", label: "Private-Capital-Beratung" },
          { to: "/expertises/origination-execution", label: "Deal-Origination & Execution" },
          { to: "/expertises/operations-structuration", label: "Operations & Strukturierung" },
          { to: "/expertises/reglementaire-conformite", label: "Regulierung & Compliance" },
          { to: "/expertises/communication-investisseurs", label: "Investorenkommunikation" },
          { to: "/expertises/intelligence-marche", label: "Marktintelligenz" },
          { to: "/expertises/conseil-strategique", label: "Strategische Beratung" },
        ],
      },
      {
        key: "clients",
        label: "Kunden",
        items: [
          { to: "/clients/investisseurs-prives", label: "Privatinvestoren" },
          { to: "/clients/entreprises", label: "Unternehmen" },
          { to: "/clients/societes-cotees", label: "Kotierte Gesellschaften" },
          { to: "/clients/fonds-institutions", label: "Fonds & Institutionen" },
          { to: "/clients/gestion-fortune", label: "Vermögensverwaltung" },
        ],
      },
      {
        key: "standards",
        label: "Standards",
        items: [
          { to: "/standards/assurance-client", label: "Mandatsqualität" },
          { to: "/standards/modele-operationnel", label: "Betriebsmodell" },
          { to: "/standards/gouvernance", label: "Governance" },
          { to: "/standards/approche-reglementaire", label: "Regulatorischer Ansatz" },
          { to: "/standards/securite", label: "Sicherheit" },
          { to: "/standards/durabilite", label: "Nachhaltigkeit" },
          { to: "/standards/programme-partenaires", label: "Partnerprogramm" },
        ],
      },
      {
        key: "investissements",
        label: "Investitionen",
        items: [
          { to: "/investissements", label: "Unser Ansatz" },
          { to: "/portfolio", label: "Portfolio" },
          { to: "/secteurs", label: "Sektoren" },
        ],
      },
    ],
    links: [
      { to: "/insights", label: "Insights" },
      { to: "/faq", label: "FAQ" },
    ],
    cta: "Private Beratung",
    breadcrumbHome: "Startseite",
    readMore: "Artikel lesen",
    ctaBand: {
      title: "Bereit, Ihre nächste Entscheidung zu strukturieren?",
      text: "Vertraulich und unverbindlich. Ein Senior-Berater antwortet innerhalb eines Arbeitstages.",
      button: "Termin anfragen",
    },
  },
};

export const LEGAL_LINKS = {
  fr: [
    { to: "/confidentialite", label: "Politique de confidentialité" },
    { to: "/conditions", label: "Conditions générales" },
    { to: "/mentions-reglementaires", label: "Mentions réglementaires" },
    { to: "/cookies", label: "Politique cookies" },
  ],
  en: [
    { to: "/confidentialite", label: "Privacy policy" },
    { to: "/conditions", label: "Terms & conditions" },
    { to: "/mentions-reglementaires", label: "Regulatory disclosures" },
    { to: "/cookies", label: "Cookie policy" },
  ],
  de: [
    { to: "/confidentialite", label: "Datenschutzerklärung" },
    { to: "/conditions", label: "Allgemeine Geschäftsbedingungen" },
    { to: "/mentions-reglementaires", label: "Regulatorische Hinweise" },
    { to: "/cookies", label: "Cookie-Richtlinie" },
  ],
};
